import React, { useState, useEffect } from 'react'
import './forum-section.scss'
import ForumList from './forum-list'
import CardInput from './card-input'
import Toast from '@/components/molecules/toast/toast'

const ForumSection = ({ id }) => {
  const [updateCounter, setUpdateCounter] = useState(0)
  const [toastNodeContent, setToastNodeContent] = useState(null)
  const handlePageUpdate = () => {
    setUpdateCounter(updateCounter + 1)
  }
  const handlerUseToast = _toastNodeContent => {
    setToastNodeContent(_toastNodeContent)
  }

  return (
    <section id={id} className="f-forum-wrapper">
      {toastNodeContent && (
        <Toast
          onClose={() => {
            setToastNodeContent(null)
          }}
        >
          {toastNodeContent}
        </Toast>
      )}
      <div className="f-forum-section">
        <CardInput
          onPageUpdate={handlePageUpdate}
          onUseToast={handlerUseToast}
        />
        <ForumList updateCounter={updateCounter} onUseToast={handlerUseToast} />
      </div>
    </section>
  )
}

export default ForumSection;
